import { useCallback } from "react";
import { getActiveLanguage, getTranslate } from "react-localize-redux";
import { useDispatch, useSelector } from "react-redux";

import { goToLink } from "@actions/common";
import { showAlert as showAlertAction } from "@components/alert/action";
import BetordoCasinoIcon from "@pages/casino/assets/backgrounds/betordo-casino-icon.webp";
import ChainspinCasinoIcon from "@pages/casino/assets/backgrounds/chainspin-casino-icon.webp";
import ChokwinCasinoIcon from "@pages/casino/assets/backgrounds/chokwin-casino-icon.webp";
import DefaultCasinoIcon from "@pages/casino/assets/backgrounds/default-casino-icon.png";
import FlashCasinoIcon from "@pages/casino/assets/backgrounds/flashsportscasino-casino-icon.webp";
import GannarCasinoIcon from "@pages/casino/assets/backgrounds/gannar-casino-icon.webp";
import MarsCasinoIcon from "@pages/casino/assets/backgrounds/mars-casino-icon.webp";
import NoveroCasinoIcon from "@pages/casino/assets/backgrounds/novero-casino-icon.webp";
import RollblockCasinoIcon from "@pages/casino/assets/backgrounds/rollblock-casino-icon.webp";
import ZigybetCasinoIcon from "@pages/casino/assets/backgrounds/zigybet-casino-icon.webp";
import BettoDefaultGameIcon from "@layouts/betto/assets/betto-default-game-icon.svg";
import { useMousePositionAnimationForMostPlayed } from "@pages/casino/hooks";
import { openGame } from "@pages/casino/utils";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
	currentLanguage: getActiveLanguage(state.localize).code,
});

const useController = ({ game, isGamePage, type }) => {
	useMousePositionAnimationForMostPlayed("#most-played-card-wrapper", game);

	const { translate, currentLanguage } = useSelector(selectTranslate);

	const dispatch = useDispatch();

	const redirect = useCallback(
		(...args) => {
			dispatch(goToLink(...args));
		},
		[goToLink]
	);

	const showAlert = useCallback(
		(...args) => {
			dispatch(showAlertAction(...args));
		},
		[showAlertAction]
	);

	const getImageSrc = () => {
		const iconHigh = game?.icon_high;
		const gameIconUrl = game?.game_icon_url;
		const iconCustomUrl = game?.icon_custom_url;

		if (iconHigh) return iconHigh;
		if (iconCustomUrl) return iconCustomUrl;
		if (gameIconUrl) return gameIconUrl;

		if (window.TENANT === "chokwin") {
			return ChokwinCasinoIcon;
		} else if (window.TENANT === "zigybet") {
			return ZigybetCasinoIcon;
		} else if (window.TENANT === "betordo") {
			return BetordoCasinoIcon;
		} else if (window.TENANT === "novero") {
			return NoveroCasinoIcon;
		} else if (window.TENANT === "chainspin") {
			return ChainspinCasinoIcon;
		} else if (window.TENANT === "rollblock") {
			return RollblockCasinoIcon;
		} else if (window.TENANT === "gannar") {
			return GannarCasinoIcon;
		} else if (window.TENANT === "flashsportscasino") {
			return FlashCasinoIcon;
		} else if (window.TENANT === "betto") {
			return BettoDefaultGameIcon;
		} else if (window.CASINO_GAME_CARDS_HAS_NEW_PLAY_ICON_AND_GAME_NAME) {
			return MarsCasinoIcon;
		} else {
			return DefaultCasinoIcon;
		}
	};

	const handleGameCardClick = () => {
		if (isGamePage) {
			openGame(game, redirect, showAlert, {}, type);

			setTimeout(() => {
				window.location.reload();
			}, 500);
		} else {
			openGame(game, redirect, showAlert, {}, type);
		}
	};

	return {
		helpers: { translate },
		state: {
			imageSrc: getImageSrc(),
			currentLanguage: currentLanguage || "en",
		},
		handlers: {
			handleGameCardClick,
		},
	};
};

export default useController;
